import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import CustomTh from '../../../../../../../components/table/CustomTh';
import CustomTooltip from '../../../../../../../components/CustomTooltip';
import { InfoChip } from '../../../../../../../components/buttons/IconButtons';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * Header cell whose tooltip describes what the column represents.
 * @param {string} tableId - Owning table id.
 * @param {string} columnKey - Translation key for the label and its `_description`.
 * @param {string} [value] - Optional value interpolated into the description.
 * @param customWidth
 * @param classes
 */
const BreakdownHeaderCell = ({ tableId, columnKey, value, customWidth, classes }) => {
    const { t } = useTranslation();

    return (
        <CustomTh tableId={tableId} customWidth={customWidth} classes={classes}>
            <CustomTooltip
                text={value ? <Trans
                    i18nKey={`${columnKey}_description`}
                    values={{ value }}
                    components={{
                        strong: <span className="fs-12px ibl-font-w-700" />
                    }}
                /> : t(`${columnKey}_description`)}
                classes={'font-color-general-950 fs-14px'}
                showIfTruncated={false}
                placement={'top'}
            >
                <span className={'d-inline-flex align-items-center justify-content-end font-color-general-950 fs-14px'}>
                    {t(columnKey)}
                    <InfoChip className={'w-16px h-16px ml-1 icon-color-secondary-600 flex-shrink-0'}/>
                </span>
            </CustomTooltip>
        </CustomTh>
    );
};

export default BreakdownHeaderCell;
